<template>
  <div class="empty-block flex align-center justify-center" :style="{ height: height }">
    <component :is="getTypeComponent" :title="title" :description="description" />
  </div>
</template>

<script>
import TextBlock from './text-block';

export default {
  props: {
    type: {
      type: String,
      default: 'text',
      validator: (value) => ['text'].includes(value),
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '100%',
    }
  },
  components: { TextBlock },
  computed: {
    getTypeComponent() {
      return this.type === 'text' ? TextBlock : null;
    },
  }
};
</script>
